import React from "react";
import { Spinner } from "react-bootstrap";

const Loader = ({ className }) => {
  return (
    <Spinner
      animation="border"
      role="status"
      className={className}
      style={{
        width: "25px",
        height: "25px",
        margin: "auto",
        display: "block",
      }}
    >
      <span className="sr-only">Loading..</span>
    </Spinner>
  );
};

export default Loader;
